import { useSuspenseQuery } from '@apollo/client';
import { GET_MOVEMENT_DATA } from '../graphql/queries/getMovementRendererData';
import { getMovementFragmentData } from '../utils/getMovementFragmentData';
import { useMemo } from 'react';

export type GateMovementData = ReturnType<typeof useMovementData>;

export const useMovementData = (movementId: number) => {
  const { data } = useSuspenseQuery(GET_MOVEMENT_DATA, {
    variables: { movementId },
  });

  const { gate, movement } = useMemo(() => {
    const { gate, ...movementFragment } = data.gateMovement;
    const movement = getMovementFragmentData(movementFragment);
    return {
      gate,
      movement,
    };
  }, [data]);

  return {
    gate,
    movement,
  };
};
